/** @jsxImportSource theme-ui */
import { Link, Flex, Text } from 'theme-ui';
import { Table } from '@component-controls/components';
import { useGetIncentiveActionsQuery } from '@/store/apiService';
import { PencilIcon } from '@heroicons/react/solid';

type Props = {};

const tableColumns = [
    {
        columnKey: 'Id',
        Header: 'Id',
        accessor: 'Id',
        width: '50px',
    },
    {
        columnKey: 'ActionType',
        Header: 'Action Type',
        accessor: 'ActionType',
    },
    {
        columnKey: 'Description',
        Header: 'Description',
        accessor: 'Description',
    },
    {
        columnKey: 'Actions',
        Cell: ({ cell }) => {
            const row = cell.row;

            return (
                <Flex sx={{ justifyContent: 'flex-end', flexGrow: 1 }}>
                    <Link variant="button" href={`/#/actions/${row.original.Id}`} title="Edit">
                        <PencilIcon width={16} height={16} />
                    </Link>
                </Flex>
            );
        },
        accessor: 'Actions',
    },
];

const Incentives = (props: Props) => {
    const actionsState = useGetIncentiveActionsQuery({});
    const actions =
        actionsState.data && actionsState.data?.Results ? actionsState.data.Results : [];

    return (
        <Flex>
            {actions.length > 0 ? (
                <Table header={true} sorting={true} columns={tableColumns} data={actions} />
            ) : (
                <Text>No actions found</Text>
            )}
        </Flex>
    );
};

export default Incentives;
